import { SelectCode } from "@corporate-tailwind/model";
import { required } from "@corporate-tailwind/corp-form";
import { AddressDto, AddressSchema } from "./address.model";

export class PickupPointDto {
    place: SelectCode | null = null;
    address: AddressDto | null = null;
    phone: string | null = null;
}

export class PickupPointSchema extends PickupPointDto {
    static schema = {
        place: { type: SelectCode, builderOption: required },
        address: { type: AddressSchema, builderOption: required },
        phone: { type: String, builderOption: required } 
    };

}